/*global sendGaEvents, mousemoveLazyLoad */
import Swiper from 'swiper';
import Intercom, { update } from '@intercom/messenger-js-sdk';
import * as constants from './config';

let isDesktop = $(window).width() >= 992;
let cookieConsentCompleted = false;
let intercomInit = false;

$(window).on('resize', () => {
  isDesktop = $(window).width() >= 992;
  refreshIntercom();
});

const triggerExitIntentBanner = () => {
  const currentUrl = window.location.pathname;
  const exitIntentModal = $('#exit-intent');
  const videoModal = $('#exit-intent-video-modal');
  const iframe = $('#exit-intent-iframe');

  // Ensure required elements exist before proceeding
  if (!exitIntentModal.length || !videoModal.length || !iframe.length) {
    return;
  };

  const extractPageKey = (url) => {
    const lastSegment = url.split('/').filter(Boolean).pop() || 'home';
    return `fyle-exit-intent-${lastSegment}`;
  };

  const showExitIntentModal = () => {
    const pageKey = extractPageKey(currentUrl);
    const isShown = sessionStorage.getItem(pageKey);
    const isVisible = $('.modal:visible');

    if (isShown || isVisible.length > 0) {
      return;
    };

    setTimeout(() => {
      exitIntentModal.modal('show');
      sessionStorage.setItem(pageKey, true);
    }, 500);
  };

  const handleDownloadClick = () => {
    $('.exit-intent-card-body-download').hide();
    $('.exit-intent-card-body-thankyou').show();
  };

  const handleExperienceClick = () => {
    // Use jQuery's attr method to set the source attribute
    iframe.attr('src', constants.exitIntentDemo);
    exitIntentModal.modal('hide');
    videoModal.modal('show');
  };

  // Only enable exit intent on desktop
  if (isDesktop) {
    $(document).on('mouseleave', showExitIntentModal);
  }

  $('#exit-intent-banner-download-btn').on('click', handleDownloadClick);
  $('#exit-intent-experience-now-btn').on('click', handleExperienceClick);
};


const clickOutsideToHideContent = (hideContent) => {
  $(document).click((event) => {
    if (!hideContent) {
      // Check the click is outside demo form modal
      const demoModal = $(event.target).closest('#contact-us-modal');

      // If demoform is opened and closed from outside send ga event
      if (demoModal.length && !demoModal.hasClass('show')) {
        sendGaEvents('click-close-modal', 'form-close', 'demo-form');
        // to trigger exit banner once per session, after demo form is closed
        if (!sessionStorage.getItem('demoFormClosed')) {
          sessionStorage.setItem('demoFormClosed', 'true');
          triggerExitIntentBanner();
        }
      }

      // send a GA event when exit intent banner is closed by clicking outside the modal
      if (event.target.id === 'exit-intent' && !$(event.target).hasClass('show')) {
        sendGaEvents('click-close-modal', 'form-close', 'demo-form');
      }
    } else {
      hideContent();
    }
  });
};

// Retriving parameters from URL for the passed param
// todo: @rohan this can be written in more generic manner
const getUrlParameter = (param) => {
  const currentUrlVariables = window.location.search.substring(1).split('&');
  for (const urlValues of currentUrlVariables) {
    const parameterName = urlValues.split('=');
    if (parameterName.length > 0 && parameterName[0] === param) {
      return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
    }
  }
};

//Return list of form to check and send Edit GA event
const getListOfFormsToCheck = () => {
  //Push form details to the form list for any other forms to send edit GA event.
  const formList = [];

  formList.push({
    formId: '#contact-us-form',
    gaEvent: {
      category: 'form-contact',
      action: 'form-edit',
      label: 'demo-form'
    },
    isEdited: false
  });
  formList.push({
    formId: '#contact-us-form-exit-intent-banner',
    gaEvent: {
      category: 'form-contact',
      action: 'form-edit',
      label: 'demo-form'
    },
    isEdited: false
  });

  return formList;
};

//Send GA event for edited form
const sendEditGAEvent = (form, event) => {
  return () => {
    if (!form.isEdited) {
      form.isEdited = true;
      sendGaEvents(event.category, event.action, event.label);
    }
  };
};

const onEditDemoForm = () => {
  const formList = getListOfFormsToCheck(); //Fetch the list of forms to listen for edit event.

  /*
    Attach event listner for each form to check whether form is made dirty or not.
    Then send GA event in the call back.
  */
  formList.forEach((form) => {
    $(form.formId).find('input').one('input', sendEditGAEvent(form, form.gaEvent));
    $(form.formId).find($('[name="number_of_employees"]')).on('click', sendEditGAEvent(form, form.gaEvent));
  });
};

const getIPAddress = () => {
  if (localStorage.getItem('ipInfo') !== null) {
    const ipInfo = JSON.parse(localStorage.getItem('ipInfo'));
    return ipInfo;
  } else {
    const ipFindData = JSON.stringify({
      ip: '127.0.0.1',
      country: 'United States'
    });
    const ipInfo = JSON.parse(ipFindData);
    return ipInfo;
  }
};

// from ipfind data store ip-address and ip-country in localstorage
const getIpInfo = (data) => {
  if (data !== null && data.ip_address !== null && data.country !== null) {
    const ipFindData = JSON.stringify({
      ip: data.ip_address,
      country: data.country
    });
    localStorage.setItem('ipInfo', ipFindData);
  }
};

const readCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';'); // Can use '$' instead of 'document' by installing jquery-cookie plugin only
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

const getContext = () => {
  const ipAddress = getIPAddress();
  return {
    hutk: readCookie('hubspotutk'),
    pageUri: $(location).attr('href'),
    pageName: document.title,
    ipAddress: ipAddress.ip
  };
};

const saveIPAddress = () => {
  const IP_FIND_KEY = '89faecdb-c41e-4ba0-8eb3-6dd1a731eddc';
  if (localStorage.getItem('ipInfo')) {
    return $.when(null);
  }
  return $.ajax({
    url: 'https://ipfind.co/me',
    type: 'get',
    data: {
      auth: IP_FIND_KEY
    },
    secure: true,
    cors: true,
    async: true,
    dataType: 'json',
    crossDomain: true,
  });
};

// first time you visit any page in the site, we will save all params
const saveSearchString = () => {
  let searchString = localStorage.getItem('search');
  if (searchString) {
    return;
  }
  searchString = window.location.search;
  if (searchString) {
    searchString = searchString.replace('?', '');
  }
  if (!searchString) {
    searchString = '';
  }
  localStorage.setItem('search', searchString);
};

// Hide the content of cookie consent banner
const hideCookieBannerContent = () => {
  // Removing the 'd-flex' class so that we can hide the banner (avoiding the situation of d-flex overriding the hide() property)
  $('.cookie-consent-banner').removeClass('d-flex');
  // Can successfully hide the banner and also hide the demo-button from the hero section as soon as the banner closes
  $('.cookie-consent-banner, .demo-button-until-banner').hide();
};

// Set the value of 'cookieConsent' key in localstorage after 15secs and hide the cookier banner
const applyTimerHideCookieBanner = () => {
  setTimeout(() => {
    if (!localStorage.getItem('cookieConsent')) {
      setCookieConsentToLocalStorage();
    }
  }, 10000);
  $('.cookie-consent-banner, .demo-button-until-banner').show();
};

const hideCookieConsentBanner = () => {
  // Hide the banner for those users who have already accepted the cookie-consent and show for those who have not accepted,
  //Show the demo button in the hero section for mobile-view, since the banner overshadows the sticky demo button,
  //Hide banner after 15secs.
  if (localStorage.getItem('cookieConsent')) {
    cookieConsentCompleted = true;
    hideCookieBannerContent();
  } else {
    applyTimerHideCookieBanner();
  }

  if (INTERCOM_APP_ID) {
    Intercom({
      app_id: INTERCOM_APP_ID,
      hide_default_launcher: !cookieConsentCompleted
    });
    intercomInit = true;
  }

  $('.banner-close').click(() => {
    //Clearing timeout when close button is clicked.
    clearTimeout(applyTimerHideCookieBanner);
    setCookieConsentToLocalStorage();
  });
};

// Set the value of 'cookieConsent' key in local storage
const setCookieConsentToLocalStorage = () => {
  localStorage.setItem('cookieConsent', 'true');
  hideCookieBannerContent();
  cookieConsentCompleted = true;
  refreshIntercom();
};

const refreshIntercom = () => {
  if (intercomInit) {
    update({ hide_default_launcher: !(isDesktop && cookieConsentCompleted) });
  }
};

const createIframeForPlayingVideo = (video) => {
  const iframe = $(document.createElement('iframe'))[0];
  iframe.style.backgroundColor = 'transparent';
  iframe.setAttribute('allowTransparency', 'true');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('src', `${video.dataset.embed}`);
  video.innerHTML = '';
  video.appendChild(iframe);
};

// Applying lazy loading on videos
const lazyloadVideos = () => {
  const videos = $('body').find('.youtube'); // Jquery alternative for querySelector
  for (let i = 0; i < videos.length; i++) {
    if (videos[i].classList.contains('autoplay')) {
      createIframeForPlayingVideo(videos[i]);
    } else {
      const source = videos[i].dataset.src;
      const image = new Image();
      image.src = source;
      image.alt = 'Video';
      image.addEventListener('load', () => {
        videos[i].appendChild(image);
      });
      videos[i].addEventListener('click', (event) => {
        createIframeForPlayingVideo(event.currentTarget);
      });
    }
  }
};

// Function to toggle navigation buttons
const toggleNavigationButtons = (swiper) => {
  const prevButton = $('.swiper-button-prev');
  const nextButton = $('.swiper-button-next');

  if (swiper.isBeginning) {
    prevButton.addClass('d-none');
  } else {
    prevButton.removeClass('d-none');
  }

  if (swiper.isEnd) {
    nextButton.addClass('d-none');
  } else {
    nextButton.removeClass('d-none');
  }
};

const videoCarousel = () => {
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    loop: false,
    speed: 500,
    autoplay: {
      enabled: true,
      delay: 2000,
    },
    on: {
      slideChange: (swiperInstance) => {
        const activeIndex = swiperInstance.activeIndex;
        $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
        $(`.swiper-pagination-bullet:eq(${activeIndex})`).addClass('swiper-pagination-bullet-active');
        toggleNavigationButtons(swiper);
        $('.swiper-wrapper').css({
          transitionProperty: 'transform', // Only apply transition to transform property
          transitionDuration: '0.5s', // Adjust the duration as needed
          transitionTimingFunction: 'ease-in-out', // Specify the timing function
        });
      },
    },
  });
  $('.swiper-pagination-bullet').on('click', (event) => {
    const index = $(event.currentTarget).index(); // Use event.currentTarget instead of this
    swiper.slideTo(index);
  });

  // Initialize toggleNavigationButtons
  toggleNavigationButtons(swiper);

  // Adjust slide positions on arrow click
  $('.swiper-button-prev').on('click', () => {
    if ($(window).width() >= 992 && $(window).width() <= 1619) {
      swiper.slidePrev(1);
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(23%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-23%)');
    } else if ($(window).width() >= 1620 && $(window).width() <= 1819) {
      swiper.slidePrev(1);
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(35%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-35%)');
    } else if ($(window).width() >= 1820) {
      swiper.slidePrev(1);
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(40%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-40%)');
    }
    else {
      swiper.slidePrev(1);
    }
    toggleNavigationButtons(swiper);
  });

  $('.swiper-button-next').on('click', () => {
    if ($(window).width() >= 992 && $(window).width() <= 1619) {
      swiper.slideNext(1);
      $('.carousel-item').css('margin-bottom','80px');
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(23%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-23%)');
    } else if ($(window).width() >= 1620 && $(window).width() <= 1819) {
      swiper.slideNext(1);
      $('.carousel-item').css('margin-bottom','80px');
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(35%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-35%)');
    } else if ($(window).width() >= 1820) {
      swiper.slideNext(1);
      $('.carousel-item').css('margin-bottom','80px');
      $('.carousel-item.swiper-slide-active').prev('.carousel-item').css('transform', 'translate(40%)');
      $('.carousel-item.swiper-slide-active').next('.carousel-item').css('transform', 'translate(-40%)');
    }
    else {
      swiper.slideNext(1);
    }
    toggleNavigationButtons(swiper);
  });
};

document.addEventListener('mousemove', () => {
  return loadTestimonialsHandler();
});

document.addEventListener('touchstart', () => {
  return loadTestimonialsHandler();
});

let swiperScriptLoaded = false;

const loadTestimonialsHandler = () => {
  if (!swiperScriptLoaded) {
    swiperScriptLoaded = true;

    // Dynamically create a script element for Swiper
    const swiperScript = document.createElement('script');
    swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.1/swiper-bundle.min.js';
    swiperScript.setAttribute('crossorigin', 'anonymous');
    swiperScript.setAttribute('referrerpolicy', 'no-referrer');
    document.body.appendChild(swiperScript);

    // Show the testimonials section
    if (document.getElementById('customer-success-yt-videos')) {
      document.getElementById('videostestimonials').style.display = 'block';
    }

    swiperScript.onload = function () {
      videoCarousel();
    };
  }

  document.removeEventListener('mousemove', loadTestimonialsHandler);
  document.removeEventListener('touchstart', loadTestimonialsHandler);
};

// lazy loading iframes (Select all iframes with the class "lazy-iframe")
const lazyIframes = document.querySelectorAll('iframe.lazy-iframe');

// Create an Intersection Observer instance
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const iframe = entry.target;
      const src = iframe.getAttribute('data-src');
      if (src) {
        iframe.setAttribute('src', src);
        observer.unobserve(iframe); // Stop observing once iframe is loaded
      }
    }
  });
});

// Start observing each lazy iframe
lazyIframes.forEach((iframe) => {
  observer.observe(iframe);
});

// smooth scroll to the targeted div
const smoothScroll = (scrollTodiv, topPadding) => {
  $('html, body').animate({
    scrollTop: $(`.${scrollTodiv}`).offset().top - topPadding
  }, 600);
};

// scroll top functionality (the arrow icon present in pricing page & all features page)
const scrollTopToggle = (scrollStartDiv, scrollEndDiv, scrollPaddingBottom = 0, scrollPaddingTop = 0) => {
  const scrollStartTop = $(scrollStartDiv).offset().top,
    scrollStartHeight = $(scrollStartDiv).outerHeight(),
    scrollEndTop = $(scrollEndDiv).offset().top,
    scrollEndHeight = $(scrollEndDiv).outerHeight(),
    windowHeight = $(window).height(),
    windowTop = $(window).scrollTop();

  if (windowTop < (scrollEndTop + scrollEndHeight - windowHeight) - scrollPaddingBottom &&
    windowTop > (scrollStartTop + scrollStartHeight - windowHeight + scrollPaddingTop)) {
    $('.scroll-top-arrow').fadeIn();
  } else {
    $('.scroll-top-arrow').fadeOut();
  }
};

// Showing and Hiding of collapse elements in feature page
const collapseFeatureList = () => {
  $('.feature-collapse-block').click((event) => {
    // To prevent double click opening of accordion
    if ($(event.currentTarget).siblings('.feature-collapse-result').hasClass('collapsing')) {
      return false;
    }
    if ($(event.currentTarget).siblings('.feature-collapse-result').hasClass('show')) {
      $(event.currentTarget).removeClass('collapse-opened').addClass('collapse-closed');
      $(event.currentTarget).find('.feature-sublist-name-section, .desc-box-before-collapse')
        .removeClass('collapse-hide-element').addClass('collapse-show-element');
      $(event.currentTarget).find('.desc-box-after-collapse')
        .addClass('collapse-hide-element').removeClass('collapse-show-element');
    } else {
      $(event.currentTarget).addClass('collapse-opened').removeClass('collapse-closed');
      $(event.currentTarget).find('.feature-sublist-name-section, .desc-box-before-collapse')
        .addClass('collapse-hide-element').removeClass('collapse-show-element');
      $(event.currentTarget).find('.desc-box-after-collapse')
        .removeClass('collapse-hide-element').addClass('collapse-show-element');
    }
  });
};

/* Debouncing is a programming practice used to ensure that time-consuming tasks do not fire so often,
  that it stalls the performance of the web page. It limits the rate at which a function gets invoked. */
const debounce = (func, delay) => {
  let debounceTimer;
  return (...args) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func(...args), delay);
  };
};

// code for copy code to clipboard in component page
$('a.copy-icon').click((event) => {
  const containerId = $(event.currentTarget).siblings('.code-content').attr('id');
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
    const range = document.createRange();
    range.selectNode(document.getElementById(containerId));
    window.getSelection().addRange(range);
    document.execCommand('copy');
  }
});

// Dropdown select - company size of demo form
const formSelectDropdown = () => {
  const hideDropdownContent = (event) => {
    // Remove the focus on select option input and close the options bar
    $(event.currentTarget).removeClass('active');
    $(event.currentTarget).find('.select-arrow-icon-primary .dropdown-closed-icon')
      .removeClass('rotate-dropdown-icon');
  };

  clickOutsideToHideContent(hideDropdownContent);

  // Opening and closing of dropdown options menu
  $('.form-dropdown.dropdown').on('click', (event) => {
    event.stopPropagation();
    $('.select-arrow-icon-primary.dropdown-closed-icon')
      .not($(event.currentTarget).find('.select-arrow-icon-primary.dropdown-closed-icon'))
      .removeClass('rotate-dropdown-icon');
    $(event.currentTarget).find('.select-arrow-icon-primary.dropdown-closed-icon')
      .toggleClass('rotate-dropdown-icon');
  });

  // On selecting company size options list item
  $('.form-dropdown.dropdown').on('click', (event) => {
    event.stopPropagation();
    // Set the value of input to the selected option value
    $(event.currentTarget).parents('.dropdown').find('input').attr('value', $(event.currentTarget).text());
    $(event.currentTarget).siblings().removeClass('selected');
    $(event.currentTarget).addClass('selected');
  });
};

//Collapsibe card to hide and reveal card content
const collapsibleCard = () => {
  const sneakPeekSection = $('.new-sneak-peek-collapse-section');
  $('.collapsible-card-header').on('click', (event) => {
    // Expand on click
    $(event.currentTarget).parent().addClass('expanded');
    // $(event.currentTarget).children('.card-content').css('visibility', 'visible');
    $(event.currentTarget).parent().find('.collapse-arrow').addClass('expanded');

    if (sneakPeekSection.length) {
      const card = $(event.currentTarget).parent().attr('id');
      $(`.${card}`).removeClass('d-none');
      $(`.${card}`).siblings().addClass('d-none');

      $(event.currentTarget).parent().siblings().removeClass('expanded');
      $(event.currentTarget).parent().siblings().children('.collapsible-card-body').removeClass('show');
      $(event.currentTarget).parent().siblings().find('.collapse-arrow').removeClass('expanded');
      // $(event.currentTarget).parent().siblings().children().find('.card-content').css('visibility', 'hidden');
    }
  });
};

// Collapsible card body in travel reimbursement page
$('.collapse-card').click((event) => {
  $('.collapse-card').removeClass('collapse-open');
  $('.sneak-peek-mobile-card').addClass('d-none');
  $(event.currentTarget).addClass('collapse-open');
  if ($(event.currentTarget).hasClass('collapse-open')) {
    $(event.currentTarget).find('.sneak-peek-mobile-card').removeClass('d-none');
  } else {
    $('.sneak-peek-mobile-card').addClass('d-none');
  }
});

// display customer logos based on India or non-India IP. Removing the d-none class from the container to show the img
// when IP call fails(ipInfo object is not present) => show non-india logos
// const displayCustomerLogos = () => {
//   const ipInfo = getIPAddress();
//   if (ipInfo) {
//     ipInfo.country === 'India' ? $('.customer-logo-india').removeClass('d-none') : $('.customer-logo-non-india').removeClass('d-none');
//   } else {
//     $('.customer-logo-non-india').removeClass('d-none');
//   }
// };

// toggle pricing based on IP for homepage(vuejs was decreasing the performance so use this method)
// const toggleHomepagePricing = () => {
//   const ipInfo = getIPAddress();
//   if (ipInfo && ipInfo.country === 'India') {
//     $('.business-price-homepage').text('Custom pricing');
//     $('.standard-price-homepage').text('Custom pricing');
//   } else {
//     $('.business-price-homepage').text('$8.99');
//     $('.standard-price-homepage').text('$4.99');
//   }
// };

const setFooterMargin = () => {
  $('.footer-styling').css('margin-top', '0');
};

// Function to randomly select 4 testimonials on each page
const testimonialRandomSelection = (testimonialId) => {
  // Get all the testimonial items in carousel
  const testimonialsArray = $(testimonialId).find('.carousel-inner .carousel-item').toArray();
  // Carousel parent where we need to append testimonials
  const testimonialParent = $(testimonialId).find('.carousel-inner');
  // Storing testimonial array to a temporary array
  const temporaryTestimonialArray = testimonialsArray.slice();
  // Initializing count to select only 4 testimonials in a page
  let count = 0;
  // Empty testimonial parent
  testimonialParent.empty();
  // Get the length of temp array
  const tempTestimonialLength = temporaryTestimonialArray.length;
  // Looping to get only 4 random testimonials
  while (count < 4) {
    // Get random index value
    const randomIndex = Math.floor(Math.random() * (tempTestimonialLength - count));
    // Get random item from testimonial array
    const randomItem = temporaryTestimonialArray[randomIndex];
    // Set active class/state to the 1st testimonial item
    if (count === 0) {
      $(randomItem).addClass('active');
    }
    // Append the random testimonial item to the parent
    testimonialParent.append(randomItem);
    // Remove that testimonial item appended from temporary array to avoid repeatation
    temporaryTestimonialArray.splice(randomIndex, 1);
    count++;
  }
};

// swipe testimonial left and right in mobile
// On touch on carousel item in mobile
const mobileSwipeCarousel = (event, id) => {
  // Get the x position on touch start
  const xPositionClicked = event.touches[0].pageX;
  // Get the y position on touch start
  const yPositionClicked = event.touches[0].pageY;
  $(event.currentTarget).on('touchmove', (e) => {
    // Get the x position on touch move
    const xPositionMoved = e.touches[0].pageX;
    // Get the y position on touch move
    const yPositionMoved = e.touches[0].pageY;

    // If there is touch move in top-bottom direction, prevent touchmove event
    if (Math.floor(yPositionClicked - yPositionMoved) !== 0) {
      $(event.currentTarget).off('touchmove');
    }
    // If the difference between x positions on start and move is +ve and sensitivity > 5, swipe right
    if (Math.floor(xPositionClicked - xPositionMoved) > 5) {
      $(event.currentTarget).parents(id).carousel('next');
    }
    // If the difference between x positions on start and move is -ve and sensitivity < -5, swipe left
    else if (Math.floor(xPositionClicked - xPositionMoved) < -5) {
      $(event.currentTarget).parents(id).carousel('prev');
    }
  });
  // On touch end/ when the user removes the finger from the element, stop the touchmove event
  $(`${id} .carousel-inner`).on('touchend', (e) => {
    $(e.currentTarget).off('touchmove');
  });
};

// Function to check if modal is open
// To resolve issue when multiple modals are open
const checkModalIsOpen = () => {
  // If modal is open
  $('.modal').on('shown.bs.modal', () => {
    // Add class to body
    $('body').addClass('modal-open');
  });
};

// Function to randomize badge section and display on page load
const badgesRandomSelection = () => {
  // Getting the array of badge items
  const badgesArray = $('.fyle-recognition-badges .fyle-badge');
  // Getting a random index of element to display
  const displayItemIndex = Math.floor(Math.random() * badgesArray.length);
  for (let i = 0; i < badgesArray.length; i++) {
    // Display the badge item with random index
    if (i === displayItemIndex) {
      // Add background class to g2-100 badge section if it is selected else remove it
      const badgeContainer = $(badgesArray[i]).parents('.fyle-recognition-badges');
      const g2TopBadge = 'g2-top-100-badge-section';
      if (i === 0) {
        badgeContainer.addClass(g2TopBadge);
      } else {
        badgesArray.removeClass(g2TopBadge);
      }

      $(badgesArray[i]).show();
      // Hide other badge items
    } else {
      $(badgesArray[i]).hide();
    }
  }
};

// Change section on hover in sneak-peek section
const sneakPeekSectionHover = () => {
  $('#software-sneak-peek-tabs .nav-link').hover((event) => {
    $('#software-sneak-peek-tabs .active').removeClass('active');
    $(event.currentTarget).addClass('active');
    $('div.software-sneak-peek-tabContent div.tab-pane').removeClass('show active');
    $($(event.currentTarget).attr('href')).addClass('show active');
  });
};

// randomly fetch three card for resources thank you page
const generateResourcesRandomCard = () => {
  $('.webinar-case-study-hero, .card-deck').children('div').each((index, element) => {
    const fetchParams = getUrlParameter('rtype'); // fetch the appended id from url
    if ($(element).hasClass(fetchParams)) { // compare the id with resource page cards classes, if match hide and dont include in random generation
      $(element).removeClass('random-case-study random-guide random-webinar');
      $(`.${fetchParams}`).css('display', 'none');
    }
  });
  // common classes for each guide, case-study and webinar cards to fetch the random class from each card
  const cardSections = ['.random-guide', '.random-case-study', '.random-webinar'];
  for (let k = 0; k < cardSections.length; k++) {
    const randomCards = $(cardSections[k]); // loop each randomcard array
    const randomCardIndex = Math.floor(Math.random() * randomCards.length);
    for (let i = 0; i < randomCards.length; i++) { // select one card from each resources
      if (i !== randomCardIndex) {
        $(randomCards[i]).hide(); // hide rest of the cards
      }
    }
  }
};

const loadImagesOnMouseMovement = () => {
  const loadAllImages = () => {
    mousemoveLazyLoad.loadAll();
  };

  document.addEventListener('touchstart', loadAllImages, {
    once: true,
    passive: true
  });
  document.addEventListener('mousemove', loadAllImages, {
    once: true
  });
};

const automaticScrollSection = () => {
  initSmoothScrolling('smooth_horizontal_scroll');
};

// Reference: https://codepen.io/wschern/pen/grXwra
const initSmoothScrolling = (animation) => {
  let sliderWidth = 0;
  let animationWidth = 0;

  // Detect the initial slider width
  $('.tweet-items-wrapper .tweet-items').each((i, element) => {
    animationWidth += $(element).outerWidth(false);
  });

  // Detect number of visible slides in viewport
  let slidesVisible = $('.tweet-container').width() / $('.tweet-container .tweet-items').outerWidth(false);
  slidesVisible = Math.ceil(slidesVisible);

  // Count slides to determine animation speed
  const slidesNumber = $('.tweet-items-wrapper .tweet-items').length;
  let speed = slidesNumber * 10;

  // adding scroll behavior for testimonial
  if ($(window).width() <= 768) {
    const totalSlides = $('.slide-counter').length;
    $('.slide-counter').text((i) => `${i + 1}/${totalSlides}`);
    speed = 0;
  }

  if ($(window).width() > 768) {
    // Clone and append the visible number of slides from start to the tail
    $('.tweet-container .tweet-items').slice(0, slidesVisible).clone().appendTo($('.tweet-items-wrapper'));
  }

  // Detect the slider width with appended tail
  $('.tweet-container .tweet-items').each((i, element) => {
    sliderWidth += $(element).outerWidth(false);
  });

  // Set slider dimensions
  $('.tweet-items-wrapper').css({
    'width': sliderWidth,
    'animation-duration': `${speed}s`,
    'animation-timing-function': 'linear',
    'transition': 'all .6s'
  });

  // Insert keyframe styles to html head
  $(`<style type="text/css">@keyframes ${animation} { 0% { margin-left: 0px; } 100% { margin-left: -${animationWidth}px; } }</style>`).appendTo('head');
  $('.tweet-container').addClass('loaded');
};

const changeSectionStyle = (mainSection, textSection) => {
  $('.text-section').addClass('faded-section');
  $(textSection).removeClass('faded-section');
  $('.image-section').addClass('d-none');
  $(mainSection).removeClass('d-none');
};

const sliderSection = () => {
  const section1TopPosition = $('#section1').position().top;
  const section2TopPosition = $('#section2').position().top;
  const section3TopPosition = $('#section3').position().top;
  const section4TopPosition = $('#section4').position().top;
  const heroHeight = $('.expense-feature-slider-section').position().top;

  $(window).scroll(() => {
    if ($(document).scrollTop() >= section1TopPosition + heroHeight && $(document).scrollTop() < section2TopPosition + heroHeight) {
      changeSectionStyle('.section1', '.text-section1');
    }
    if ($(document).scrollTop() >= section2TopPosition + heroHeight && $(document).scrollTop() < section3TopPosition + heroHeight) {
      changeSectionStyle('.section2', '.text-section2');
    }
    if ($(document).scrollTop() >= section3TopPosition + heroHeight && $(document).scrollTop() < section4TopPosition + heroHeight) {
      changeSectionStyle('.section3', '.text-section3');
    }
    if ($(document).scrollTop() >= section4TopPosition + heroHeight) {
      changeSectionStyle('.section4', '.text-section4');
    }
  });
};

const downloadPdfFile = (filename, fileurl) => {
  const userAgent = window.navigator.userAgent;
  const trident = userAgent.indexOf('Trident/');
  if (trident > -1) {
    window.location.href = fileurl;
  } else {
    const link = document.createElement('a');
    link.href = fileurl;
    link.download = filename;
    link.setAttribute('target', '_blank');
    link.click();
  }
};

const initHelloBar = () => {
  $('.hello-bar-link').click(() => {
    localStorage.setItem('helloBar', true);
  });

  if (!localStorage.getItem('helloBar')) {
    const helloBar = $('.hello-bar');
    helloBar.slideDown('slow');
    if ($(window).scrollTop() < 10) {
      $('.navbar, .navbar-mobile').addClass('hello-bar-at-top');
    }
  }

  $('.hello-close-icon').click(() => {
    localStorage.setItem('helloBar', true);
    $('.hello-bar').slideUp(300);
    $('.navbar').removeClass('hello-bar-at-top');
    sendGaEvents('hello-bar', 'hello-bar-close', 'decoffer2020-hello-bar');
    $('.navbar-mobile').removeClass('hello-bar-at-top');
  });
};

const setExpenseFeatureActive = () => {
  // Add default hover state to the expense feature card
  $('.expense-feature').addClass('hover-state');
  $('.container-wrapper').mouseover((event) => {
    $(event.currentTarget).removeClass('hover-state');
    $('.container-wrapper').removeClass('hover-state');
  });
};

//Function to filter and remove duplicates items in the side navigation menu.
const getUniqueSideNavList = (sliderSection, allListItem) => {
  //Array to return filtered nav list.
  const uniqueSideNavList = [];
  //To keep track of index which is unique.
  let index = 0;
  //Looping through each slider section.
  sliderSection.each((i, section) => {
    //Getting number of list items in each slider section.
    const numOfList = $(section).find('li').length;
    const imgContainer = $(section).find('.slider-image-section-container');
    //Looping through each sub-sections inside slider section.
    imgContainer.each(() => {
      //Finding unique item and pushing into the list.
      uniqueSideNavList.push(allListItem[uniqueSideNavList.length + index]);
    });
    //Updating index for each slider section.
    index += numOfList;
  });
  return uniqueSideNavList;
};

//Timeline scroll animation
const companyTimelineAnimation = () => {
  const halfOfScreen = $(window).height() / 2;
  const timeLineBackground = $('.time-line-background');
  const indicatorIcon = $('.stem-icon');
  const timeLineHandler = () => {
    const bottomPoint = timeLineBackground.offset().top;
    const halfOfScreenInDocument = $(document).scrollTop() + halfOfScreen;
    const spaceToReachMiddle = halfOfScreenInDocument - bottomPoint;
    if (bottomPoint <= halfOfScreenInDocument && spaceToReachMiddle > 50 && spaceToReachMiddle <= 500) {
      timeLineBackground.css('height', spaceToReachMiddle);
    }
    indicatorIcon.each((i, icon) => {
      const iconTop = $(icon)[0].getBoundingClientRect().top;
      if (iconTop <= halfOfScreen) {
        $(icon).addClass('blue-bg');
      }
      else {
        if (i !== 0) {
          $(icon).removeClass('blue-bg');
        }
      }
    });
  };

  $(window).on('scroll', () => {
    timeLineHandler();
  });

};

const carouselTestimonial = (testimonial) => {
  const totalItems = $(`${testimonial} .carousel-item`).length;
  let currentIndex = $('div.carousel-item.active').index() + 1;
  let currentIndexActive;
  let downIndex;
  $(testimonial).on('slid.bs.carousel', () => {
    currentIndex = $(`${testimonial} div.active`).index() + 1;
    $(`${testimonial} .slide-count`).html(`${currentIndex}/${totalItems}`);
  });
  $(`${testimonial} .slide-count`).html(`${currentIndex}/${totalItems}`);

  $(`${testimonial} .carousel-control-next`).click(() => {
    currentIndexActive = $(`${testimonial} div.carousel-item.active`).index() + 2;
    if (totalItems >= currentIndexActive) {
      downIndex = $(`${testimonial} div.carousel-item.active`).index() + 2;
      $(`${testimonial} .slide-count`).html(`${currentIndexActive}/${totalItems}`);
    }
    else {
      $(`${testimonial} .slide-count`).html(`1/${totalItems}`);
    }
  });

  $(`${testimonial} .carousel-control-prev`).click(() => {
    downIndex = downIndex - 1;
    if (downIndex >= 1) {
      $(`${testimonial} .slide-count`).html(`${downIndex}/${totalItems}`);
    }
    else {
      $(`${testimonial} .slide-count`).html(`${totalItems}/${totalItems}`);
      downIndex = $(`${testimonial} div.carousel-item.active`).index() + 2;
    }
  });
};
const carouselNormalization = () => {

  window.heights = []; //create empty array to store height values

  const normalizeHeights = () => {
    $('.multi-item-carousel .carousel-inner .carousel-item .item-details').each((i, element) => {
      window.heights.push($(element).outerHeight());
    });
    window.tallest = Math.max(...window.heights);
    $('.multi-item-carousel .carousel-inner .carousel-item .item-details').each((i, element) => {
      $(element).children().css('min-height', `${window.tallest}px`);
    });
  };
  normalizeHeights();
};
const setCardsActive = (cardElement) => {
  cardElement.addClass('hover-state');
  $('.card-column').mouseover((event) => {
    $(event.currentTarget).removeClass('hover-state');
    cardElement.removeClass('hover-state');
  });
};

// reference: https://medium.com/@claudiaconceic/infinite-plain-javascript-slider-click-and-touch-events-540c8bd174f2
const horizantalSlider = () => {
  const slider = document.getElementById('slider'),
    sliderItems = document.getElementById('slides'),
    prev = document.getElementById('prev'),
    next = document.getElementById('next');

  const slide = (wrapper, items, prev, next) => {
    let posX1 = 0,
      posX2 = 0,
      posInitial,
      posFinal,
      index = 0,
      allowShift = true;
    const threshold = 15,
      slides = items.getElementsByClassName('item'),
      slidesLength = slides.length,
      slideSize = items.getElementsByClassName('item')[0].offsetWidth,
      slideMargin = parseInt($('.item').css('marginRight')),
      firstSlide = slides[0],
      lastSlide = slides[slidesLength - 1],
      cloneFirst = firstSlide.cloneNode(true),
      cloneLast = lastSlide.cloneNode(true);

    // Clone first and last slide
    items.appendChild(cloneFirst);
    items.insertBefore(cloneLast, firstSlide);
    wrapper.classList.add('loaded');

    // Touch events
    items.addEventListener('touchstart', (e) => { dragStart(e); });
    items.addEventListener('touchend', (e) => { dragEnd(e); });
    items.addEventListener('touchmove', (e) => { dragAction(e); });

    // Click events
    prev.addEventListener('click', () => { shiftSlide(-1); });
    next.addEventListener('click', () => { shiftSlide(1); });

    // Transition events
    items.addEventListener('transitionend', () => { checkIndex(); });

    const dragStart = (e) => {
      e = e || window.event;
      e.preventDefault();
      posInitial = items.offsetLeft;

      if (e.type === 'touchstart') {
        posX1 = e.touches[0].clientX;
      } else {
        posX1 = e.clientX;
        document.onmouseup = dragEnd;
        document.onmousemove = dragAction;
      }
    };

    const dragAction = (e) => {
      e = e || window.event;

      if (e.type === 'touchmove') {
        posX2 = posX1 - e.touches[0].clientX;
        posX1 = e.touches[0].clientX;
      } else {
        posX2 = posX1 - e.clientX;
        posX1 = e.clientX;
      }
      items.style.left = `${items.offsetLeft - posX2}px`;
    };

    const dragEnd = () => {
      posFinal = items.offsetLeft;
      if (posFinal - posInitial < -threshold) {
        shiftSlide(1, 'drag');
      } else if (posFinal - posInitial > threshold) {
        shiftSlide(-1, 'drag');
      } else {
        items.style.left = `${posInitial}px`;
      }

      document.onmouseup = null;
      document.onmousemove = null;
    };

    const shiftSlide = (dir, action) => {
      items.classList.add('shifting');

      if (allowShift) {
        if (!action) { posInitial = items.offsetLeft; }

        if (dir === 1) {
          items.style.left = `${posInitial - slideSize - slideMargin}px`;
          index++;
        } else if (dir === -1) {
          items.style.left = `${posInitial + slideSize + slideMargin}px`;
          index--;
        }
      }

      allowShift = false;
    };

    const checkIndex = () => {
      items.classList.remove('shifting');

      if (index === -1) {
        items.style.left = `${-(slidesLength * slideSize)}px`;
        index = slidesLength - 1;
      }

      if (index === slidesLength) {
        items.style.left = `${-(1 * slideSize)}px`;
        index = 0;
      }

      allowShift = true;
    };
  };

  slide(slider, sliderItems, prev, next);
};

// Get the IP information - used for adding workflow in HS for Sales team: related to HS calendar scheduler
const ipInfo = getIPAddress();
if (ipInfo && ipInfo.country) {
  // Set the value of the hidden input field to ipInfo.country (default value will be United States, set from HTML)
  const el = document.getElementById('ip-country-updated');
  el.value = ipInfo.country;
}

window.smoothScroll = smoothScroll;

export {
  getUrlParameter,
  getContext,
  getIpInfo,
  saveIPAddress,
  saveSearchString,
  debounce,
  hideCookieConsentBanner,
  getIPAddress,
  lazyloadVideos,
  collapseFeatureList,
  setFooterMargin,
  formSelectDropdown,
  clickOutsideToHideContent,
  testimonialRandomSelection,
  onEditDemoForm,
  checkModalIsOpen,
  badgesRandomSelection,
  loadImagesOnMouseMovement,
  scrollTopToggle,
  mobileSwipeCarousel,
  sneakPeekSectionHover,
  triggerExitIntentBanner,
  generateResourcesRandomCard,
  automaticScrollSection,
  sliderSection,
  downloadPdfFile,
  initHelloBar,
  setExpenseFeatureActive,
  getUniqueSideNavList,
  companyTimelineAnimation,
  setCardsActive,
  carouselTestimonial,
  carouselNormalization,
  horizantalSlider,
  collapsibleCard,
  videoCarousel
};